// Client-side twin of server/utils/makeAPIMap.ts. Kept as a tiny duplicate rather than a shared import
// because the app/ and server/ build contexts don't share a module graph here (no shared/ dir set up).
// Used by defineCollectionStore.ts to derive a collection's id-map from its data array on the client,
// instead of the server serializing an (almost byte-identical) `map` object over the wire — that map was
// ~50% of the wire size for every collection that has one (sites/neighborhoods/trails). See the
// bootstrap-payload-budget memory / docs/superpowers/plans/2026-08-13-offline-pwa.md.
export const makeAPIMap = (data: any[]) => {
    const map: Record<string, any> = {};

    try {
        const flattenedRecords = data.flat(1);
        flattenedRecords.forEach((record) => {
            map[record.id] = record;
        });
    } catch (error) {
        console.error('Error building map based on the data', error);
    }

    return map;
};
